import { ReactElement, useState } from 'react';
import { PAGE_ICONS } from 'pages/AnnualUserAccessReview/_const';
import PageWithBreadcrumbs from 'pages/AnnualUserAccessReview/layouts/UARPageWithBreadcrumbs';
import TerminateForm from './TerminateForm';
import HelpBar, {
	Main,
} from 'pages/ApplicationRequest/components/containers/1616BridgesEpic/components/HelpBar';
import Typography from '@mui/material/Typography';
import HelpLayout from 'layouts/HelpLayout';
import CssBaseline from '@mui/material/CssBaseline';
import FormLayout from 'layouts/FormLayout';

/**
 * View where manager can review and validate employee access
 * @returns {ReactElement} User Access Review Employee Review page view
 */
const ReviewView = () => {
	const [sOpen, setOpen] = useState(false);
	return (
		<PageWithBreadcrumbs
			currentPageLabel={'Terminate Staff'}
			CurrentPageIcon={PAGE_ICONS.TERMINATE}
		>
			<CssBaseline />
			<Main open={sOpen}>
				<FormLayout
					title={'Terminate Staff'}
					setOpen={() => setOpen(!sOpen)}
				>
					<TerminateForm />
				</FormLayout>
			</Main>
			<HelpBar open={sOpen} setOpen={setOpen}>
				<HelpLayout title='Terminate Staff'>
					<Typography>
						Allows for termination of staff members. Termination
						will result in user's losing access to all UMPC
						applications.
					</Typography>
					<br></br>
					<Typography>
						For more information, please check on{' '}
						<a
							target='_blank'
							rel='noopener noreferrer'
							href='https://infonet.upmc.com/infonet/ls/content/1566556746580335/manager-guide-to-terminating-all-user-accounts-pdf-1764800005'
						>
							InfoNet
						</a>
					</Typography>
				</HelpLayout>
			</HelpBar>
		</PageWithBreadcrumbs>
	);
};

export default ReviewView;
